import { makeStyles } from "@fluentui/react-components";
export const useDndDragLayerStyles = makeStyles({
    root: {
        position: "fixed",
        pointerEvents: "none",
        zIndex: 100,
        left: "0 /* @noflip */",
        top: 0
    },
    container: {}
});
